import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from "../components/SEO";


const steps = ['Basic Info', 'Project Details', 'Appointment', 'Confirm'];

const cities = ['Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai', 'Pune', 'Kolkata', 'Ahmedabad', 'Jaipur', 'Kochi'];
const projectTypes = ['Full Home Interior', 'Kitchen Only', 'Wardrobe', 'Bathroom', 'Living Room', 'Multiple Rooms', 'Renovation', 'Commercial Space'];
const budgets = ['₹3L – ₹7L', '₹7L – ₹15L', '₹15L – ₹30L', '₹30L – ₹60L', '₹60L+'];
const timeSlots = ['9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM'];

function getDateOptions() {
  const dates = [];
  for (let i = 1; i <= 7; i++) {
    const d = new Date();
    d.setDate(d.getDate() + i);
    dates.push({
      label: d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }),
      value: d.toISOString().split('T')[0],
    });
  }
  return dates;
}

export default function Consult() {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({
    name: '', email: '', phone: '', city: '',
    projectType: '', bhk: '', budget: '', notes: '',
    date: '', time: '',
    mode: 'home', // home | online | store
  });
  const [submitted, setSubmitted] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const canNext = () => {
    if (step === 0) return form.name && form.phone && form.city;
    if (step === 1) return form.projectType && form.budget;
    if (step === 2) return form.date && form.time;
    return true;
  };

  const handleSubmit = () => {
    setSubmitted(true);
  };

  if (submitted) {
    return (
       <>
    <SEO/>
      <div style={{ paddingTop: 68, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8f8f8' }}>
        <div style={{ textAlign: 'center', padding: 48, background: '#fff', border: '1px solid #e2e2e2', maxWidth: 480, width: '100%' }}>
          <div style={{ fontSize: 64, marginBottom: 20 }}>✓</div>
          <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 28, color: '#0a0a0a', marginBottom: 12 }}>Consultation Booked!</div>
          <p style={{ fontSize: 14, color: '#6b6b6b', lineHeight: 1.7, marginBottom: 24 }}>
            Thank you, <strong>{form.name}</strong>! Our designer will call you on <strong>{form.phone}</strong> on {form.date} at {form.time} to discuss your {form.projectType} project.
          </p>
          <div style={{ background: '#f0f0f0', padding: '20px', marginBottom: 24, textAlign: 'left' }}>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', color: '#9a9a9a', marginBottom: 12 }}>Booking Summary</div>
            {[['City', form.city], ['Project', form.projectType], ['Budget', form.budget], ['Date', form.date], ['Time', form.time], ['Mode', form.mode]].map(([k, v]) => (
              <div key={k} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 8 }}>
                <span style={{ color: '#9a9a9a' }}>{k}</span>
                <span style={{ fontWeight: 500, color: '#0a0a0a', textTransform: 'capitalize' }}>{v}</span>
              </div>
            ))}
          </div>
          <button className="btn-primary" style={{ width: '100%', marginBottom: 12 }} onClick={() => navigate('/')}>Back to Home</button>
          <button className="btn-outline" style={{ width: '100%' }} onClick={() => navigate('/projects')}>Explore Projects</button>
        </div>
      </div>
      </>
    );
  }

  const dates = getDateOptions();

  return (
    <div style={{ paddingTop: 68 }}>
      {/* Hero */}
      <div style={{ background: '#0a0a0a', padding: '60px 40px' }}>
        <div className="container">
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: '#c4a882', marginBottom: 12 }}>Free Consultation</div>
          <h1 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 'clamp(30px,4vw,48px)', color: '#fff', fontWeight: 400, marginBottom: 12 }}>Book Your Free Design Consultation</h1>
          <p style={{ fontSize: 14, color: '#9a9a9a' }}>No cost. No obligation. Just expert advice tailored to your home.</p>
        </div>
      </div>

      {/* Progress */}
      <div style={{ background: '#fff', borderBottom: '1px solid #e2e2e2', padding: '20px 0' }}>
        <div className="container">
          <div style={{ display: 'flex', gap: 0, position: 'relative' }}>
            {steps.map((s, i) => (
              <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, position: 'relative' }}>
                {i > 0 && <div style={{ position: 'absolute', top: 16, right: '50%', left: '-50%', height: 2, background: i <= step ? '#0a0a0a' : '#e2e2e2', zIndex: 0 }} />}
                <div style={{
                  width: 34, height: 34, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  background: i < step ? '#0a0a0a' : i === step ? '#0a0a0a' : '#e2e2e2',
                  color: i <= step ? '#fff' : '#9a9a9a',
                  fontSize: 13, fontWeight: 700, position: 'relative', zIndex: 1,
                  border: i === step ? '3px solid #c4a882' : 'none',
                }}>
                  {i < step ? '✓' : i + 1}
                </div>
                <div style={{ fontSize: 12, color: i === step ? '#0a0a0a' : '#9a9a9a', fontWeight: i === step ? 600 : 400 }}>{s}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <section className="section-alt" style={{ minHeight: '60vh' }}>
        <div className="container" style={{ maxWidth: 680 }}>
          <div style={{ background: '#fff', border: '1px solid #e2e2e2', padding: 40 }}>

            {/* Step 0: Basic Info */}
            {step === 0 && (
              <div>
                <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 26, marginBottom: 28 }}>Tell Us About Yourself</h2>
                <div className="form-group">
                  <label className="form-label">Full Name *</label>
                  <input className="form-input" placeholder="Your full name" value={form.name} onChange={e => set('name', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Phone Number *</label>
                  <input className="form-input" placeholder="+91 98765 43210" value={form.phone} onChange={e => set('phone', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Email Address</label>
                  <input className="form-input" placeholder="your@email.com" type="email" value={form.email} onChange={e => set('email', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Your City *</label>
                  <select className="form-select" value={form.city} onChange={e => set('city', e.target.value)}>
                    <option value="">Select your city</option>
                    {cities.map(c => <option key={c}>{c}</option>)}
                  </select>
                </div>
              </div>
            )}

            {/* Step 1: Project Details */}
            {step === 1 && (
              <div>
                <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 26, marginBottom: 28 }}>Project Details</h2>
                <div className="form-group">
                  <label className="form-label">Project Type *</label>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 10 }}>
                    {projectTypes.map(p => (
                      <button key={p} onClick={() => set('projectType', p)} style={{
                        padding: '12px 16px', border: '1.5px solid',
                        borderColor: form.projectType === p ? '#0a0a0a' : '#e2e2e2',
                        background: form.projectType === p ? '#0a0a0a' : '#fff',
                        color: form.projectType === p ? '#fff' : '#4a4a4a',
                        fontSize: 13, cursor: 'pointer', textAlign: 'left', transition: 'all 0.2s',
                      }}>{p}</button>
                    ))}
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Home Size</label>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    {['1BHK', '2BHK', '3BHK', '4BHK+', 'Villa', 'Commercial'].map(b => (
                      <button key={b} onClick={() => set('bhk', b)} style={{
                        padding: '8px 16px', border: '1.5px solid',
                        borderColor: form.bhk === b ? '#0a0a0a' : '#e2e2e2',
                        background: form.bhk === b ? '#0a0a0a' : '#fff',
                        color: form.bhk === b ? '#fff' : '#4a4a4a',
                        fontSize: 13, cursor: 'pointer', transition: 'all 0.2s',
                      }}>{b}</button>
                    ))}
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Budget Range *</label>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {budgets.map(b => (
                      <button key={b} onClick={() => set('budget', b)} style={{
                        padding: '12px 20px', border: '1.5px solid', textAlign: 'left',
                        borderColor: form.budget === b ? '#0a0a0a' : '#e2e2e2',
                        background: form.budget === b ? '#0a0a0a' : '#fff',
                        color: form.budget === b ? '#fff' : '#4a4a4a',
                        fontSize: 14, cursor: 'pointer', transition: 'all 0.2s',
                      }}>{b}</button>
                    ))}
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Additional Notes</label>
                  <textarea className="form-input" placeholder="Any specific requirements or questions..." value={form.notes} onChange={e => set('notes', e.target.value)} rows={4} style={{ resize: 'vertical' }} />
                </div>
              </div>
            )}

            {/* Step 2: Appointment */}
            {step === 2 && (
              <div>
                <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 26, marginBottom: 28 }}>Choose Appointment</h2>
                <div className="form-group">
                  <label className="form-label">Consultation Mode</label>
                  <div style={{ display: 'flex', gap: 10 }}>
                    {[{ v:'home', label:'Home Visit', icon:'🏠' }, { v:'online', label:'Video Call', icon:'💻' }, { v:'store', label:'At Store', icon:'🏪' }].map(m => (
                      <button key={m.v} onClick={() => set('mode', m.v)} style={{
                        flex: 1, padding: '14px 10px', border: '1.5px solid',
                        borderColor: form.mode === m.v ? '#0a0a0a' : '#e2e2e2',
                        background: form.mode === m.v ? '#0a0a0a' : '#fff',
                        color: form.mode === m.v ? '#fff' : '#4a4a4a',
                        fontSize: 13, cursor: 'pointer', display: 'flex', flexDirection: 'column',
                        alignItems: 'center', gap: 6, transition: 'all 0.2s',
                      }}>
                        <span style={{ fontSize: 22 }}>{m.icon}</span>
                        <span style={{ fontWeight: 600 }}>{m.label}</span>
                      </button>
                    ))}
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Preferred Date *</label>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    {dates.map(d => (
                      <button key={d.value} onClick={() => set('date', d.label)} style={{
                        padding: '10px 14px', border: '1.5px solid',
                        borderColor: form.date === d.label ? '#0a0a0a' : '#e2e2e2',
                        background: form.date === d.label ? '#0a0a0a' : '#fff',
                        color: form.date === d.label ? '#fff' : '#4a4a4a',
                        fontSize: 12, cursor: 'pointer', transition: 'all 0.2s', textAlign: 'center',
                      }}>{d.label}</button>
                    ))}
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Preferred Time *</label>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8 }}>
                    {timeSlots.map(t => (
                      <button key={t} onClick={() => set('time', t)} style={{
                        padding: '10px 6px', border: '1.5px solid',
                        borderColor: form.time === t ? '#0a0a0a' : '#e2e2e2',
                        background: form.time === t ? '#0a0a0a' : '#fff',
                        color: form.time === t ? '#fff' : '#4a4a4a',
                        fontSize: 12, cursor: 'pointer', transition: 'all 0.2s',
                      }}>{t}</button>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Step 3: Confirm */}
            {step === 3 && (
              <div>
                <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 26, marginBottom: 28 }}>Confirm Your Booking</h2>
                <div style={{ background: '#f8f8f8', padding: '24px', marginBottom: 24 }}>
                  {[
                    ['Name', form.name], ['Phone', form.phone], ['City', form.city],
                    ['Project', form.projectType], ['Budget', form.budget],
                    ['Date', form.date], ['Time', form.time], ['Mode', form.mode],
                  ].map(([k, v]) => v && (
                    <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #e2e2e2', fontSize: 14 }}>
                      <span style={{ color: '#9a9a9a', fontWeight: 500 }}>{k}</span>
                      <span style={{ color: '#0a0a0a', fontWeight: 600, textTransform: 'capitalize' }}>{v}</span>
                    </div>
                  ))}
                </div>
                <div style={{ background: '#f0f0f0', padding: '16px 20px', marginBottom: 24 }}>
                  <div style={{ fontSize: 13, color: '#4a4a4a', lineHeight: 1.7 }}>
                    ✓ Free, no-obligation consultation<br/>
                    ✓ Expert designer assigned to your project<br/>
                    ✓ 3D design preview within 48 hours<br/>
                    ✓ Transparent, itemized quotation
                  </div>
                </div>
              </div>
            )}

            {/* Navigation */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 32, paddingTop: 24, borderTop: '1px solid #e2e2e2' }}>
              {step > 0 ? (
                <button className="btn-outline" onClick={() => setStep(s => s - 1)}>← Back</button>
              ) : <div />}
              {step < steps.length - 1 ? (
                <button
                  className="btn-primary"
                  onClick={() => canNext() && setStep(s => s + 1)}
                  style={{ opacity: canNext() ? 1 : 0.4, cursor: canNext() ? 'pointer' : 'not-allowed' }}
                >Continue →</button>
              ) : (
                <button className="btn-gold" onClick={handleSubmit}>Confirm Booking ✓</button>
              )}
            </div>
          </div>

          {/* Trust badges */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: 32, marginTop: 28, flexWrap: 'wrap' }}>
            {['🔒 100% Secure', '🎁 Completely Free', '📞 No Spam Calls', '⭐ 4.9 Rating'].map(b => (
              <div key={b} style={{ fontSize: 13, color: '#9a9a9a', fontWeight: 500 }}>{b}</div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
